import React, {  Component } from 'react';

export default class RequestReturnOopReasonDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('RequestReturnOopReasonDialog', false);
    }

    componentDidMount() {
        // window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Reason Required</h2>
                        <p>Out of policy returns require a reason. 
                        <br/>Include relevant details, i.e. service case number, etc.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestReturnOopReasonDialog.js